import React, { useState, useEffect } from "react";
import Scrollbar from "react-scrollbars-custom";
import {
  Paper,
  Typography,
  Grid,
  Divider,
  Card,
  CardContent,
  CardActionArea,
} from "@material-ui/core";

import noDataImage from "../Images/nodata.webp";

import Loading from "./Loading";

import { withStyles, makeStyles } from "@material-ui/styles";
import styles from "./Styles/BookScreenStyles";

import API from "../Services/API";

const LocationSelection = (props) => {
  let { classes } = props;
  const { dbname, modes,locationIds,locNames} = props.value;
  const [didInitLoad, setDidInitLoad] = useState(false);
  const [call, setCall] = useState(false);
  const [locations, setLocations] = useState("");

  const [noData, setNoData] = useState("");
  const [loading, setLoading] = useState(false);

  const api = API.create();

  useEffect(() => {
    if(props.methodselection.newCall){
      setDidInitLoad(false);
      props.methodselection.newCall = false;
    }
    if (!didInitLoad) {
      setLoading(true);
      initialLoad();
    }
  });

  const initialLoad = () => {
    api.getPracticeLocations({ dbname: dbname }, (locRes) => {
      if (locRes.status === 200) {
        setNoData("false");
        let locResObj = locRes.data;
        if (locResObj.length > 0) {
            setLocations(locResObj);
            if (!call && modes==1 && locationIds!=null && locationIds!=-1) {
              setCall(true);
              locationSelected(locationIds,locNames,dbname);
            }
          
        }
      } else {
        setNoData(true);
      }
      setLoading(false);
    });
    setDidInitLoad(true);
  };

  const locationSelected  = (locationId,locName,dbName)=>{
    props.methodselection.changeSelection(locationId,locName,dbName);
  }

  return (
    <div>
      {loading && (
      <Loading />
    )}
    {!loading && (
      <Grid container  spacing={1} elevation={0} >
      {locations.length == 0 && <Typography variant="p" className={classes.noData}>None</Typography>}
      {locations.length > 0 &&
        Object.keys(locations).map((key, index) => {
          return (
            <React.Fragment>
              {locations[key].locationData.map(
                (subKey, subIndex) => {
                  return (
                    <Grid item  xs={4} sm={4} md={4} lg={2} className={classes.itemPanelGrid} justify="space-between">
                        <Card className={classes.itemPanelCard}>
                          <CardActionArea onClick={locationSelected.bind(this,locations[key].locationData[subIndex].patientPortalFeatureConfigId,locations[key].locationData[subIndex].patientPortalFeatureConfigDesc,locations[key].dbname)}>
                            <CardContent  className={classes.contentHover} style={{
                                    display:"flex",alignItems:"center",justifyContent:"center"
                                  }}>
                              <Typography variant="subtitle1"  style={{
                                    fontSize:14,
                                    color:"#4f4f4f"
                                  }}>
                                  {locations[key].locationData[
                                    subIndex
                                  ].patientPortalFeatureConfigDesc
                                    
                                    .split(" ")
                                    .map(
                                      (s) =>
                                        s.charAt(0).toUpperCase() +
                                        s.substring(1)
                                    )
                                    .join(" ")}
                                </Typography>
                            </CardContent>
                          </CardActionArea>
                        </Card>
                    </Grid>  
                  );
                }
              )}
            </React.Fragment>
          );
        })}
      </Grid>
    )}
    </div>
  );
};

export default withStyles(styles)(LocationSelection);
